<div class="layout-container" [class.calendar-fullscreen-mode]="bulkSchedulingStateService.isFullscreenMode()">

    <!-- * Can be used for modals | currently not used -->
    <div class="overlay"></div>

    <email-confirmation-banner
        *ngIf="showEmailBanner"
        (confirm)="openEmailConfirmation()"
        (close)="dismissEmailBanner()">
    </email-confirmation-banner>

    <div id="main">
        <ng-container *ngTemplateOutlet="topNot"></ng-container>

        <div id="container-1" class="container">
            <!-- NAVBAR: Left -->
            <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
            <!-- / NAVBAR: Left -->

            <div id="container-2" class="container invisible-buttons" 
                 [style.padding-left]="bulkSchedulingStateService.isActive() || bulkSchedulingStateService.isFullscreenMode() ? '0px !important' : null">
                @if (innerWidth > 599) {
                <div class="toolbar-wrapper">
                    <!-- TOOLBAR: Below fixed -->
                    <ng-container *ngTemplateOutlet="toolbar"></ng-container>
                    <!-- / TOOLBAR: Below fixed -->
    
                    <!-- CONTENT -->
                    <app-on-going-event
                        [currentEvents]="currentEvents"
                        style="z-index: 10;"
                    ></app-on-going-event>
                </div>
                <content style="z-index: 1;">
                </content>
                <!-- / CONTENT -->
                } @else {
                <small-layout>
                    <!-- CONTENT -->
                    <div page-content class="page-content">
                        <content class="svp-content"></content>
                    </div>
                    <!-- / CONTENT -->
                </small-layout>
                }

            </div>
        </div>
    </div>

    <!-- QUICK PANEL -->
    <fuse-sidebar name="quickPanel" position="right" class="quick-panel">
        <quick-panel style="height: 100%;"></quick-panel>
    </fuse-sidebar>
    <!-- / QUICK PANEL -->

    <!-- ----------------------------------------------------------------------------------------------------- -->
    <!-- @ PARTIALS

         TOOLBAR -->
    <ng-template #topNot>
        <top-notification [@slideInOut] (close)="setNotToDefault()" *ngIf="topNotConfig && topNotConfig.show && !fuseConfig.layout.topNotification?.hidden" [action]="topNotConfig.action" [message]="topNotConfig.message" [email_adress]="email_address">
        </top-notification>
    </ng-template>

    <!-- / TOOLBAR -->


    <ng-template #toolbar>
        <toolbar *ngIf="!fuseConfig.layout.toolbar.hidden" [ngClass]="[
                fuseConfig.layout.toolbar.position,
                fuseConfig.layout.toolbar.background
            ]" style="z-index: 1 !important;">
        </toolbar>
    </ng-template>
    <!-- / TOOLBAR -->

    <!-- LEFT NAVBAR -->
    <ng-template #leftNavbar>
        <ng-container *ngIf="(!editingEvent || innerWidth < 1099)">
            <fuse-sidebar name="navbar" class="navbar-fuse-sidebar" [folded]="fuseConfig.layout.navbar.folded" lockedOpen="gt-md" *ngIf="!fuseConfig.layout.navbar.hidden && !bulkSchedulingStateService.isFullscreenMode()">
                <navbar [variant]="fuseConfig.layout.navbar.variant" class="left-navbar" [ngClass]="fuseConfig.layout.navbar.background">
                </navbar>
            </fuse-sidebar>
            <fuse-sidebar name="navbar-fullscreen" class="navbar-fuse-sidebar" *ngIf="bulkSchedulingStateService.isFullscreenMode()">
                <navbar [variant]="fuseConfig.layout.navbar.variant" class="left-navbar" [ngClass]="fuseConfig.layout.navbar.background">
                </navbar>
            </fuse-sidebar>
        </ng-container>
    </ng-template>
    <!-- / LEFT NAVBAR -->
</div>

<app-paiement-print class="printer" [data]="printerData" *ngIf="printer === 'pp'"></app-paiement-print>
<app-print class="printer" [data]="printerData" *ngIf="printer === 'p'"></app-print>
<app-planning-print class="printer" [data]="printerData" *ngIf="printer === 'ppl'"></app-planning-print>
<agency-invoice-print *ngIf="printer === 'aip'" class="printer" [data]="printerData"></agency-invoice-print>
<recu-agence-payment size="A5" *ngIf="printer === 'par'" class="printer print-recu" [data]="printerData"></recu-agence-payment>